/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery, Box, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { DAILY, WEEKLY, MONTHLY, QUARTERLY, LATER } from 'constants/constant';
import reportSettingStyles from '../ReportSettings.style';
import moment from 'moment';
import { useSelector } from 'react-redux';

function TimeField(props) {
	const { selectedDate, handleDateChange, scheduleType } = props;
	const [time, setTime] = useState('12:00:00');
	const [meridiem, setMeridiem] = useState('AM');
	const isSmallScreen = useMediaQuery('(max-width:360px)');
	const isEditEnabled = useSelector((state) => state.dashboardReducer.isEditEnabled);
	const classes = reportSettingStyles({ isSmallScreen });
	const currentDate = new Date(selectedDate);
	const date = `${currentDate.getFullYear()}-${
		currentDate.getMonth() + 1
	}-${currentDate.getDate()}`;

	const handleTimeFormat = (value) => {
		const spitTime = value.split(':');
		spitTime[0] = Number(spitTime[0]) + 12;

		return spitTime.join(':');
	};

	const handleTimeSelect = (event) => {
		const value = `${event.target.value}`;
		let newTime = value;
		const splitTime = value.split(':');
		const selectedHr = Number(splitTime[0]);

		if ((selectedHr === 12 && meridiem === 'AM') || (selectedHr < 12 && meridiem === 'PM')) {
			newTime = handleTimeFormat(value);
		}
		handleDateChange(`${date} ${newTime}`);
		setTime(value);
	};

	const handleMeridiemSelect = (event) => {
		let newTime = time;
		const splitTime = time.split(':');
		const selectedHr = Number(splitTime[0]);
		if (
			(selectedHr === 12 && event.target.value === 'AM') ||
			(selectedHr < 12 && event.target.value === 'PM')
		) {
			newTime = handleTimeFormat(time);
		}
		handleDateChange(`${date} ${newTime}`);
		setMeridiem(event.target.value);
	};

	const getTime = () => {
		const currentTime = moment().set('minute', '00').set('second', '00');
		const newTime = currentTime.add(1, 'hour');
		const formattedDate = newTime.format('MM/DD/YYYY');
		const formattedTime = newTime.format('h:mm:ss');
		const meridiem = newTime.format('A');
		setMeridiem(meridiem);
		setTime(formattedTime);

		handleDateChange(`${formattedDate} ${newTime.format('HH:mm:ss')}`);
	};

	useEffect(() => {
		if (scheduleType === LATER && currentDate.getTime() < new Date().getTime()) {
			getTime();
		} else {
			const currentTime = moment(currentDate).set('minute', '00').set('second', '00');
			handleDateChange(`${date} ${currentTime.format('HH:mm:ss')}`);
		}
	}, [selectedDate, meridiem]);

	useEffect(() => {
		if (scheduleType === LATER && !isEditEnabled) {
			getTime();
		}
		// In case of Fixed Deliver Time the default selection should be 3 AM
		if ([DAILY, WEEKLY, MONTHLY, QUARTERLY].includes(scheduleType) && !isEditEnabled) {
			setTime('3:00:00');
			setMeridiem('AM');
		}
	}, [scheduleType, isEditEnabled]);

	useEffect(() => {
		if (isEditEnabled) {
			const hr = new Date(selectedDate).getHours();
			const parsetime = moment(hr, ['HH']).format('h A');
			const splitTime = parsetime.split(' ');
			setTime(`${splitTime[0]}:00:00`);
			setMeridiem(splitTime[1]);
		}
	}, [selectedDate]);

	return (
		<Box className={[MONTHLY].includes(scheduleType) ? classes.timeField : classes.dateTimeField}>
			<FormControl
				variant="outlined"
				className={
					[QUARTERLY, DAILY].includes(scheduleType) ? classes.timeQuaterField : classes.timeField
				}>
				<InputLabel id="week-label">{'Time'}</InputLabel>
				<Select
					labelId="time-label"
					id="time-select"
					value={time}
					className={classes.select}
					MenuProps={{ classes: { paper: classes.menuPaper } }}
					onChange={handleTimeSelect}
					label="Time">
					{Array.apply(1, Array(12)).map(function (x, i) {
						const timeVal = i + 1;
						return (
							<MenuItem
								className={`${classes.text} ${classes.menuItem}`}
								key={`${timeVal}:00:00`}
								value={`${timeVal}:00:00`}>
								{`${timeVal}:00`}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
			<FormControl
				variant="outlined"
				className={
					[QUARTERLY, DAILY].includes(scheduleType) ? classes.timeQuaterField : classes.timeField
				}>
				<Select
					labelId="meridiem-label"
					id="meridiem-select"
					value={meridiem}
					className={classes.select}
					onChange={handleMeridiemSelect}
					MenuProps={{ classes: { paper: classes.menuPaper } }}>
					<MenuItem className={`${classes.text} ${classes.menuItem}`} value="AM">
						AM
					</MenuItem>
					<MenuItem className={`${classes.text} ${classes.menuItem}`} value="PM">
						PM
					</MenuItem>
				</Select>
			</FormControl>
		</Box>
	);
}

TimeField.propTypes = {
	selectedDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
	handleDateChange: PropTypes.func.isRequired,
	scheduleType: PropTypes.string.isRequired
};

export default TimeField;
